import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { AssetTagResponse, AssetTagCreateRequest, AssetTagUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { EnumToComboValues, GridColumnHelper } from '../utils';
import { AssetTagDetailsSectionHandler } from './details.section';
import { CustomFieldsSectionHandler } from '../shared/info.section';
import { AssetGroupingService } from 'app/services';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';

@RegisterEntityHandler('assettag')
@Injectable()
export class AssetTagHandler extends EntityHandler<AssetTagResponse> {

    constructor(
        admin: AdminEditorService,
        private grouping: AssetGroupingService
    ) {
        super(admin);
    }

    states = ['active', 'deleted'];

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listAssetTags/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listAssetTags(ownerId, offset, limit, sort, filter), 3).then(response => ({
            ...response,
            type: 'assettag',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.ASSETTAGS'),
        }));
    }

    getEntity(id: string): Promise<AssetTagResponse> {
        return this.admin.getCached(`getAssetTag/${id}`, api => api.entities.getAssetTag(id), 10);
    }

    createEntity(ownerId: string, entity: AssetTagCreateRequest): Promise<AssetTagResponse> {
        entity.ownerId = ownerId;
        return this.admin.applyUpdate(api => api.entities.createAssetTag(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updateAssetTag(entity.id, { state: state as any }));
    }
    
    getGridColumns(ownerId: string): Promise<IKuiTableCol[]> {

        return this.admin.getCached(`getClient/${ownerId}`, api => api.accounts.getClient(ownerId), 60).then(client => {

            const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.ASSETTAG.COLUMNS');

            const columns: IKuiTableCol[] = [
                grid.IconTextColumn('name', 'NAME', ICONS.assettag),
                grid.TextColumn('serialNumber', 'SERIAL_NUMBER'),
                grid.IdNameTextColumn('assetTagType', 'ASSET_TAG_TYPE', 120),
                grid.ComboColumn('mode', 'MODE', EnumToComboValues(this.admin.i18n, 'ADMIN.EDITORS.ASSETTAG.MODES', ['movable', 'fixed', 'stock']), 80),
                grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'ADMIN.STATES', this.states, ['deleted']), 80),
                grid.IdNameTextColumn('asset', 'ASSET', 120),
            ];

            (client.customFields['assettag'] || []).forEach(customField => {
                columns.push({
                    ...grid.TextColumn(`fields.${customField.id}`, customField.title, 100),
                    format: (_col, row) => {
                        return row.fields && row.fields[customField.id];
                    },
                });
            });

            columns.push(grid.TimeAgoColumn('modifiedDate', 'MODIFIED'));
            return columns;
        });

    }

    getEditorSections(ownerId: string, _entity: any): Promise<SectionHandlerGroup<AssetTagResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new AssetTagDetailsSectionHandler(this.admin, ownerId, this.grouping),
                new CustomFieldsSectionHandler<AssetTagResponse>(this.admin, ownerId, 'assettag'),
            ],
        }]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: AssetTagUpdateRequest, sections: FormSectionHandler<AssetTagResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'assettag',
            entity: {}, // set up some defaults if you want
            sections: [
                new AssetTagDetailsSectionHandler(this.admin, ownerId, this.grouping),
                new CustomFieldsSectionHandler<AssetTagResponse>(this.admin, ownerId, 'assettag'),
            ],
        });
    }

}













